import ColumnChart from "@/app/charts/ColumnChart";
import TreemapChart from "@/app/charts/TreemapChart";
import VennChart from "@/app/charts/VennChart";
import UpsetChart from "@/app/charts/UpsetChart";
import SankeyChart from "@/app/charts/SankeyChart";
import WordCloudChart from "@/app/charts/WordCloudChart";
import { getObjectLen } from "@/app/utils/utils";
import ChartSection, { ChartTitle } from "@/app/components/ChartSection";

export function AuthorCharts({
  pubPerYear,
  pubPerArea,
  pubPerAreaInvestigator,
  pubPerOrigin,
  pubPerCoauthors,
  topKeywords,
  overlapingDocuments,
  combinationCounts,
  authorName,
  authorId,
}) {
  return (
    <div>
      {getObjectLen(pubPerYear[1]) > 0 && (
        <ChartSection
          titleAs="h3"
          title="Volumen de publicaciones por año"
          tooltip="Número de documentos del autor agrupados por año de publicación. Los documentos sin año aparecen como «Sin año»."
          Chart={<ColumnChart data={pubPerYear[1]} serieName={authorName} />}
          table={pubPerYear}
        />
      )}

      {getObjectLen(pubPerAreaInvestigator[1]) > 0 && (
        <ChartSection
          titleAs="h3"
          title="Publicaciones por áreas de conocimiento (top 10)"
          tooltip="Distribución de documentos según las áreas de conocimiento asociadas. Un documento puede contar en más de un área. Se muestran las 10 áreas con más documentos."
          Chart={<TreemapChart data={pubPerAreaInvestigator[1]} />}
          table={pubPerAreaInvestigator}
        />
      )}

      {getObjectLen(pubPerArea[1]) > 0 && (
        <ChartSection
          titleAs="h3"
          title="Publicaciones por áreas temáticas (top 10)"
          tooltip="Distribución de documentos según las áreas temáticas. Un documento puede contar en más de un área. Se muestran las 10 áreas con más documentos."
          Chart={<TreemapChart data={pubPerArea[1]} />}
          table={pubPerArea}
        />
      )}

      {Object.values(pubPerOrigin[1]).some((value) => value !== 0) && (
        <>
          <ChartSection
            titleAs="h3"
            title="Publicaciones por origen"
            tooltip="Total de documentos indexados en cada fuente (Scopus, Google Scholar, RRAAE, ORCID). Un mismo documento puede aparecer en varias fuentes."
            Chart={
              <VennChart data={overlapingDocuments} serieName={authorName} />
            }
            table={pubPerOrigin}
          />
          <div className="mt-5 p-5 shadow-lg">
            <ChartTitle
              as="h3"
              title="Solapamiento entre fuentes"
              tooltip="Muestra cuántos documentos están en una sola fuente y cuántos se solapan entre Google Scholar, Scopus, RRAAE y ORCID."
            />
            <UpsetChart rawData={combinationCounts} color="#041953" />
          </div>
        </>
      )}

      {getObjectLen(pubPerCoauthors[1]) > 0 && (
        <ChartSection
          titleAs="h3"
          title="Coautores destacados por número de publicaciones (top 10)"
          tooltip="Cada flujo cuenta documentos conjuntos con esa persona, no coautores únicos. El indicador de Coautores cuenta personas distintas. Se muestran los 10 con más publicaciones conjuntas."
          Chart={<SankeyChart data={pubPerCoauthors[1]} from={authorName} />}
          table={pubPerCoauthors}
        />
      )}

      {getObjectLen(topKeywords) > 0 && (
        <div className="mt-5 p-5 shadow-lg">
          <ChartTitle
            as="h3"
            title="Palabras clave más frecuentes"
            tooltip="El tamaño indica cuántas veces aparece cada término. Haz clic en una palabra para ver los documentos filtrados por esa palabra clave."
          />
          <WordCloudChart
            data={topKeywords}
            link={`/author/${authorId}/documents?p=1`}
          />
        </div>
      )}
    </div>
  );
}
